import { defineComponent as d, ref as f, onMounted as p, onUpdated as v, provide as g, openBlock as h, createElementBlock as b, normalizeClass as C, createVNode as l, unref as n, withCtx as i, renderSlot as _ } from "vue";
import { theme as k, themeOverrides as S } from "./ghl-ui.es252.js";
import "./ghl-ui.es253.js";
import "./ghl-ui.es254.js";
import { GHLLanguageKeys as a } from "./ghl-ui.es255.js";
import { date_en_US as s } from "./ghl-ui.es256.js";
import y from "./ghl-ui.es257.js";
import L from "./ghl-ui.es258.js";
import { NModalProvider as U } from "./ghl-ui.es259.js";
import { sv as w } from "./ghl-ui.es260.js";
import { date_sv as B } from "./ghl-ui.es261.js";
import { es as P } from "./ghl-ui.es262.js";
import { date_es as x } from "./ghl-ui.es263.js";
import { ptBR as N } from "./ghl-ui.es264.js";
import { date_pt_BR as R } from "./ghl-ui.es265.js";
import { ptPT as A } from "./ghl-ui.es266.js";
import { date_pt_PT as F } from "./ghl-ui.es267.js";
import { no as z } from "./ghl-ui.es268.js";
import { date_no as I } from "./ghl-ui.es269.js";
import { it as M } from "./ghl-ui.es270.js";
import { date_it as O } from "./ghl-ui.es271.js";
import { de as T } from "./ghl-ui.es272.js";
import { date_de as W } from "./ghl-ui.es273.js";
import { frFR as $ } from "./ghl-ui.es274.js";
import { date_fr_FR as j } from "./ghl-ui.es275.js";
import { frCA as D } from "./ghl-ui.es276.js";
import { date_fr_CA as E } from "./ghl-ui.es277.js";
import { fi as G } from "./ghl-ui.es278.js";
import { date_fi as H } from "./ghl-ui.es279.js";
import { nl as K } from "./ghl-ui.es280.js";
import { date_nl as V } from "./ghl-ui.es281.js";
import { da as q } from "./ghl-ui.es282.js";
import { date_da as J } from "./ghl-ui.es283.js";
import { enUS as u } from "./ghl-ui.es284.js";
const Q = d({
  name: "UIContentWrap",
  inheritAttrs: !0
}), X = d({
  ...Q,
  props: {
    fullScreen: {
      type: Boolean,
      default: !1
    },
    locale: {
      type: String,
      default: a.englishUS
    },
    notificationConfig: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const r = t, e = f(u), o = f(s), m = () => {
      switch (function() {
        return r != null && r.locale ? r.locale.includes("_") ? (console.warn(
          `Deprecated used of '_' in the language '${r.locale}', please change to use hyphen '-'.`
        ), r.locale.replace("_", "-")) : r.locale : a.englishUS;
      }()) {
        case a.englishUS:
        default: {
          e.value = u, o.value = s;
          break;
        }
        case a.danish: {
          e.value = q, o.value = J;
          break;
        }
        case a.dutch: {
          e.value = K, o.value = V;
          break;
        }
        case a.finnish: {
          e.value = G, o.value = H;
          break;
        }
        case a.frenchCanada: {
          e.value = D, o.value = E;
          break;
        }
        case a.frenchFrance: {
          e.value = $, o.value = j;
          break;
        }
        case a.german: {
          e.value = T, o.value = W;
          break;
        }
        case a.italian: {
          e.value = M, o.value = O;
          break;
        }
        case a.norwegian: {
          e.value = z, o.value = I;
          break;
        }
        case a.portuguesePortugal: {
          e.value = A, o.value = F;
          break;
        }
        case a.portugueseBrazil: {
          e.value = N, o.value = R;
          break;
        }
        case a.spanish: {
          e.value = P, o.value = x;
          break;
        }
        case a.swedish: {
          e.value = w, o.value = B;
          break;
        }
      }
    };
    return p(() => {
      m();
    }), v(() => {
      m();
    }), g("customLocale", e), (c, Y) => (h(), b("div", {
      class: C(["font-sans hl-wrapper-container", { "full-screen": t.fullScreen }])
    }, [
      l(n(y), {
        theme: n(k),
        "theme-overrides": n(S),
        locale: e.value,
        "date-locale": o.value
      }, {
        default: i(() => [
          l(n(L), {
            "container-class": t.notificationConfig.containerClass,
            "container-style": t.notificationConfig.containerStyle,
            to: t.notificationConfig.to,
            placement: t.notificationConfig.placement,
            max: t.notificationConfig.max,
            scrollable: t.notificationConfig.scrollable
          }, {
            default: i(() => [
              l(n(U), null, {
                default: i(() => [
                  _(c.$slots, "default")
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["container-class", "container-style", "to", "placement", "max", "scrollable"])
        ]),
        _: 3
      }, 8, ["theme", "theme-overrides", "locale", "date-locale"])
    ], 2));
  }
}), Fe = X;
export {
  Fe as default
};
